export default {
  cancel: "Abbrechen",
  confirm: "Bestätigen",
  next: "Okay",
  back: "Zur vorherigen Seite",
  toClosedOrdersOverview: "Zur Auftragsübersicht",
};
